import React from 'react';
import ReactDOM from 'react-dom';
import PriceRange from 'components/search/price-range/price-range';
import logger from 'logger';
import InitData from 'core/app/data/init-data';

const getPriceRangeParams = searchParams => {
    if (searchParams) {
        try {
            const params = JSON.parse(searchParams);
            return {
                fromPrice: params.fromPrice || 1,
                toPrice: params.toPrice || 5000
            };
        } catch (e) {
            logger(e);
        }
    }
    return null;
}

module.exports = (elementsToAttachTo, options = {}) => {
    const initData = InitData.current();
    const priceRangeParams = getPriceRangeParams(initData.searchParams);
    if (!elementsToAttachTo || !priceRangeParams) {
        return;
    }
    try {
        const sliderElementsAsArray = Array.from(elementsToAttachTo);
        sliderElementsAsArray.map(sliderElement => {
            ReactDOM.render(
                <PriceRange {...{
                    rangeStart: 1,
                    rangeEnd: 5000,
                    handleStart: priceRangeParams['fromPrice'],
                    handleEnd: priceRangeParams['toPrice'],
                    searchResults: sliderElement.dataset.options,
                    gaCategory: 'Search Filters',
                    navigateEvent: options.navigateEvent || 'ui:navigate'
                }} />,
                sliderElement
            );
            $(document).on('ui:teardown', () => {
                ReactDOM.unmountComponentAtNode(sliderElement);
            });
        });
    } catch (e) {
        logger(e);
    };
}


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/containers/price-slider.jsx